<div
    class="flex flex-col min-w-0 overflow-hidden"
    [ngClass]="{'absolute inset-0': !isWebComponent}">

    <mat-drawer-container
        class="flex-auto h-full bg-card dark:bg-transparent"
        (backdropClick)="onBackdropClicked()">

        <!--//drawerMode-->
         <mat-drawer
            class="item-details-drawer w-full sm:w-100 md:w-100 dark:bg-gray-900"
            [mode]="drawerMode" 
            [opened]="false"
            [position]="'end'"
            [disableClose]="true"
            #matDrawer>
            <router-outlet></router-outlet>
        </mat-drawer>

        <mat-drawer-content class="flex flex-col bg-gray-100 dark:bg-transparent">

            <!-- Main -->
            <div class="flex flex-col flex-auto">

                <div class="my-2">
                    <desktop-agent-banner></desktop-agent-banner>
                </div>

                <!-- Header -->
                <div class="flex flex-row items-center justify-start  sm:py-6 md:px-6 border-b bg-card dark:bg-transparent file-manager-explorer-header m-0">
                    <!-- Sidebar toggle button -->
                    <button *ngIf="!isWebComponent"  mat-icon-button (click)="_fileManagerComponent.fileManagerDrawer.toggle()">
                        <mat-icon [svgIcon]="'heroicons_outline:bars-3'"></mat-icon>
                    </button>

                    <button *ngIf="isWebComponent"  mat-icon-button (click)="clearSearch()">
                        <mat-icon [svgIcon]="'heroicons_outline:arrow-left'"></mat-icon>
                    </button>

                    <!-- Title -->
                    <div class="flex flex-col ml-3">
                        <div class="text-2xl font-extrabold tracking-tight leading-none">Search Results</div>
                        <div class="flex items-center mt-0.5 font-medium text-secondary">
                            <ng-container *ngIf="!this.routeFolderId">
                                {{totalAssets.folders}} folders, {{totalAssets.files}} files
                            </ng-container>
                            <!-- Breadcrumbs -->
                            <ng-container *ngIf="paths && paths.length>0 && this.routeFolderId">
                                <div class="flex items-center space-x-2">
                                    <a class="text-primary cursor-pointer" [routerLink]="['/apps/file-manager']">Home</a>
                                    <div class="">/</div>
                                    <ng-container *ngFor="let path of paths; let last = last;">
                                        <ng-container *ngIf="!last">
                                            <a class="text-primary cursor-pointer" [routerLink]="['/apps/file-manager/folders/', path.id]">{{path.name}}</a>
                                        </ng-container>
                                        <ng-container *ngIf="last">
                                            <div matTooltip="{{path.name}}">{{path.name}}</div>
                                        </ng-container>
                                        <ng-container *ngIf="!last">
                                            <div class="">/</div>
                                        </ng-container>
                                    </ng-container>
                                </div>
                            </ng-container>
                        </div>
                    </div>
                    <!-- Actions -->
                    <div class="ml-auto">
                        <button mat-button 
                            class="header-action-button-minimal"
                            [color]="'primary'" 
                            [matTooltip]="viewMode === 'cards' ? 'View List' : 'View Cards'"
                            (click)="toggleViewMode()">
                            <mat-icon [svgIcon]="viewMode === 'cards' ? 'mat_outline:view_list' : 'mat_outline:grid_view'"></mat-icon>
                        </button>
                        <!-- View Stats -->
                    </div>
                </div>
                
                <!--Header Controls-->
                <div class="col file-manager-filter-panel text-md font-semibold 
                    text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5 fade-transition">
                    
                    <!--Show/Hide panel of additional filter parameters for current view list-->
                    <mat-expansion-panel 
                        #filterPanel="matExpansionPanel" 
                        hideToggle
                        class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'20px'">
                            
                        </mat-expansion-panel-header>
                        <!--Panel of Search Options-->
                        <div>
                            <!--filter by date modified; if null, by date created/uploaded-->
                            <mat-form-field appearance="fill" 
                                matTooltip="Date Modified"
                                class="file-manager-filter-select-time fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix mr-2"> 
                                <mat-icon
                                    class="icon-size-5"
                                    [svgIcon]="'heroicons_outline:clock'"
                                    matPrefix></mat-icon>
                                <mat-select [placeholder]="'Date Modified'">
                                    <mat-option [value]="'any'">Any</mat-option>
                                    <mat-option [value]="'today'">Today</mat-option>
                                    <mat-option [value]="'yesterday'">Yesterday</mat-option>
                                    <mat-option [value]="'last7'">Last 7 days</mat-option>
                                    <mat-option [value]="'last30'">Last 30 days</mat-option>
                                    <mat-option [value]="'last90'">Last 90 days</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <!--filter by file type-->
                            <mat-form-field 
                                class="file-manager-filter-select-type fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix mr-2"
                                matTooltip="File Type"> 
                                <mat-icon
                                    class="icon-size-5"
                                    [svgIcon]="'heroicons_outline:document-check'"
                                    matPrefix></mat-icon>
                                <mat-select [placeholder]="'Type'">
                                    <mat-option [value]="'any'"><mat-icon [svgIcon]="'heroicons_outline:check'"></mat-icon>Any</mat-option>
                                    <mat-option [value]="'pdf'"><mat-icon [svgIcon]="util.getFileTypeImage('pdf')"></mat-icon>PDF</mat-option>
                                    <mat-option [value]="'document'"><mat-icon [svgIcon]="util.getFileTypeImage('doc')"></mat-icon>Document</mat-option>
                                    <mat-option [value]="'spreadsheet'"><mat-icon [svgIcon]="util.getFileTypeImage('xls')"></mat-icon>Spreadsheet</mat-option>
                                    <mat-option [value]="'image'"><mat-icon [svgIcon]="util.getFileTypeImage('png')"></mat-icon>Photo or Image</mat-option>
                                    <mat-option [value]="'presentation'"><mat-icon [svgIcon]="util.getFileTypeImage('ppt')"></mat-icon>Presentation</mat-option>
                                    <mat-option [value]="'audio'"><mat-icon [svgIcon]="util.getFileTypeImage('mp3')"></mat-icon>Audio</mat-option>
                                    <mat-option [value]="'video'"><mat-icon [svgIcon]="util.getFileTypeImage('mp4')"></mat-icon>Video</mat-option>
                                    <mat-option [value]="'archive'"><mat-icon [svgIcon]="util.getFileTypeImage('zip')"></mat-icon>Archive/Zip</mat-option>
                                    <mat-option [value]="'folder'"><mat-icon [svgIcon]="'heroicons_outline:folder'"></mat-icon>Folder</mat-option>
                                </mat-select>
                            </mat-form-field>
                           
                            <!-- Filter by Labels -->
                            <mat-form-field 
                                class="file-manager-filter-select-label fuse-mat-dense fuse-mat-rounded fuse-mat-emphasized-affix mr-2"
                                matTooltip="Labels"> 
                                <mat-icon
                                    class="icon-size-5"
                                    [svgIcon]="'heroicons_outline:tag'"
                                    matPrefix></mat-icon>
                                   
                                <mat-select [placeholder]="'Labels'">
                                    <mat-option [value]="'any'">Any</mat-option>
                                    <mat-option *ngFor="let label of labels" 
                                        [ngClass]="labelColors[label.color]?.combined"
                                        [value]="label.id">
                                        {{ label.name }}
                                    </mat-option>
                                    <!-- Add more label options here -->
                                </mat-select>
                            </mat-form-field>
                        </div>
                        
                    </mat-expansion-panel>
                   
                    <!--Show/Hide panel of additional filter parameters for current view list-->
                    <mat-expansion-panel 
                        #multiItemSelectPanel="matExpansionPanel"
                        class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5 file-manager-multi-item-actions file-grid z-10 sticky top-0 grid">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'0px'">
                            
                        </mat-expansion-panel-header>
                        <!--Panel of Control Options for multiple files-->
                        <div class="row flex">
                            <div class="row flex justify-start items-center mr-2">
                                <button mat-icon-button 
                                    matTooltip="Cancel bulk action"
                                    (click)="cancelBulkAction()">
                                    <mat-icon
                                        class="icon-size-5"
                                        [svgIcon]="'heroicons_outline:x-mark'"></mat-icon>
                                </button>
                            </div>
                            <div class="flex row items-center mr-6">
                                <span class="mr-2">{{selectedRows.length}}</span>
                                <span>selected</span>
                            </div>
                            <div class="row flex justify-start items-center justify-center">
                               
                                <span [matTooltip]="isFolderRowSelected() ? 'Cannot bulk download folders' : 'Download'" matTooltipPosition="above">
                                    <button mat-icon-button [disabled]="isFolderRowSelected()" (click)="download_multi()">
                                        <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                                    </button>
                                </span>
                                <!-- Toggle favourite star button -->
                                <button mat-icon-button matTooltip="Favorite" 
                                    (click)="toggleStar_multi()">
                                    <mat-icon
                                        class="icon-size-4"
                                        [svgIcon]="'feather:star'"></mat-icon>
                                </button>
                                <button mat-icon-button [matTooltip]="'Trash' | lpmLabel:'deleteLabelText'"
                                    [appAction]="{ action: 'delete', item: selectedRows }"
                                    (click)="trash_multi()">
                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                                </button>              
                            </div>
                        </div>
                    </mat-expansion-panel>

                    <!--Show/Hide panel of stats-->
                    <mat-expansion-panel 
                        #statsPanel="matExpansionPanel"
               
                        (opened)="isStatsPanelOpen = true" (closed)="isStatsPanelOpen = false"
                        class="w-full bg-gray-50 dark:bg-black dark:bg-opacity-5">
                        <mat-expansion-panel-header [collapsedHeight]="'0px'" [expandedHeight]="'16px'">
                           
                        </mat-expansion-panel-header>
                        <ng-container *ngIf="isStatsPanelOpen">
                            <dv-bar></dv-bar>
                        </ng-container>
                    </mat-expansion-panel>

                </div>
                <!-- Items list -->
                <ng-container *ngIf="folders && (folders?.length > 0 || files?.length > 0); else noItems">

                    <!-- Cards view -->
                    <ng-container *ngIf="viewMode === 'cards'">
                        <div class="p-6 md:p-8 space-y-8 fade-transition">
                            
                            <!-- Folders -->
                            <ng-container *ngIf="folders?.length > 0">
                                <div>
                                    <div class="font-medium">Folders</div>
                                    <div
                                        class="flex flex-wrap -m-2 mt-2">
                                        <ng-container *ngFor="let folder of folders; trackBy:trackByFn">
                                            <div 
                                            class="relative w-40 h-40 m-2 p-4 shadow rounded-2xl bg-card item_card">
                                                <button  class="absolute z-20 top-1.5 right-1.5 w-8 h-8 min-h-8"
                                                    matTooltip="Actions"
                                                    [matMenuTriggerFor]="fmItemActionMenu_card_folder"
                                                    mat-icon-button>
                                                    <mat-icon
                                                        class="icon-size-5"
                                                        [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
                                                </button>
                                                <mat-menu #fmItemActionMenu_card_folder="matMenu" class="file-manager-item-action-menu">
                                        
                                                    <button mat-menu-item [appAction]="{ action: 'share', item: folder }" (click)="shared(folder)">
                                                        <mat-icon class="icon-size-4" svgIcon="mat_outline:share"></mat-icon>
                                                        <span>Share</span>
                                                    </button>

                                                    <div class="border-t"></div>
                                                    <button mat-menu-item [appAction]="{ action: 'rename', item: folder }" (click)="_fileManagerComponent.renameItemDialog(folder)">
                                                        <mat-icon class="icon-size-4" svgIcon="mat_outline:edit"></mat-icon>
                                                        <span>Rename</span>
                                                    </button>
                                                    
                                                    <button mat-menu-item
                                                        [matMenuTriggerFor]="fmItemActionMenu_card_folder_sub1">
                                                        <mat-icon class="icon-size-4" svgIcon="feather:folder"></mat-icon>
                                                        <span>Organize</span>
                                                    </button>  
    
                                                    <mat-menu #fmItemActionMenu_card_folder_sub1="matMenu" class="file-manager-item-action-menu-sub">
                                                        <button mat-menu-item
                                                            [appAction]="{ action: 'move', item: folder }"
                                                            (click)="move(folder)">
                                                            <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                                                            <span>Move</span>
                                                        </button>
                                                        <button mat-menu-item
                                                            (click)="toggleStar(folder)">
                                                            <mat-icon class="icon-size-4" svgIcon="heroicons_outline:star"></mat-icon>
                                                            <span>Star</span>
                                                        </button>
                                                        <button mat-menu-item
                                                            [matMenuTriggerFor]="labels.length>0 ? fmItemActionMenu_sub_labels : null">
                                                            <mat-icon class="icon-size-4" svgIcon="feather:tag"></mat-icon>
                                                            <span>Labels</span>
                                                        </button>
                                                        <mat-menu #fmItemActionMenu_sub_labels="matMenu" class="file-manager-item-action-menu-sub">
                                                            <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                                                                <button mat-menu-item
                                                                    (click)="toggleLabel(folder.id, label.id, checkbox)"
                                                                    matRipple>
                                                                    <mat-checkbox
                                                                        class="pointer-events-none label-chip" #checkbox
                                                                        [ngClass]="labelColors[label.color]?.combined"
                                                                        [color]="'primary'"
                                                                        [checked]="selectedLabel(label.id, folder.labels)"
                                                                        [disableRipple]="true">
                                                                        {{label?.name}}
                                                                    </mat-checkbox>
                                                                    
                                                                </button>
                                                            </ng-container>
                                                        </mat-menu>
                                                    </mat-menu>
                                                    <div class="border-t"></div>
                                                    <button *appAction="{ action: 'delete', item: folder }"
                                                        mat-menu-item
                                                        (click)="trash(folder)">
                                                        <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                                                        <span>{{ 'Trash' | lpmLabel:'deleteLabelText' }}</span>
                                                    </button>
                                                </mat-menu>
                                                <a
                                                    class="z-10 absolute inset-0 flex flex-col p-4 cursor-pointer"
                                                    [routerLink]="['/apps/file-manager/folders/', folder.id]">
                                                    <div class="aspect-[9/6]">
                                                        <div class="flex items-center justify-center h-full">
                                                            <!-- Icon -->
                                                            <mat-icon
                                                                class="icon-size-14 text-hint opacity-50"
                                                                [svgIcon]="'heroicons_solid:folder'"></mat-icon>
                                                        </div>
                                                    </div>
                                                    <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium">
                                                        <div
                                                            class="truncate"
                                                            [matTooltip]="folder.name">{{folder.name}}</div>
                                                        <ng-container *ngIf="folders.length">
                                                            <div class="text-secondary truncate">{{folders.length}}</div>
                                                        </ng-container>
                                                    </div>
                                                </a>
                                            </div>
                                        </ng-container>
                                    </div>
                                </div>
                            </ng-container>
            
                                 <!-- Files -->
                            <ng-container *ngIf="!isLoading && files && files.length > 0">
                                <div>
                                    <div class="font-medium">Files</div>
                                    <div
                                        class="flex flex-wrap -m-2 mt-2">
                                        <ng-container *ngFor="let file of files; trackBy:trackByFn">
                                            <div
                                                (dblclick)="onFileDblClick(file)"
                                                class="relative w-40 h-40 m-2 p-4 shadow rounded-2xl bg-card item_card cursor-pointer">
                                                <button  class="absolute z-20 top-1.5 right-1.5 w-8 h-8 min-h-8"
                                                    matTooltip="Actions"
                                                    [matMenuTriggerFor]="fmItemActionMenu_card"
                                                    mat-icon-button>
                                                    <mat-icon
                                                        class="icon-size-5"
                                                        [svgIcon]="'heroicons_outline:ellipsis-vertical'"></mat-icon>
                                                </button>
                                            <mat-menu #fmItemActionMenu_card="matMenu" class="file-manager-item-action-menu">
                                                <button mat-menu-item
                                                    [appAction]="{ action: 'download', item: file }"
                                                    (click)="download(file)">
                                                    <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                                                    <span>Download</span>
                                                </button>
                                                <button mat-menu-item [appAction]="{ action: 'share', item: file }" (click)="shared(file)">
                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:share"></mat-icon>
                                                    <span>Share</span>
                                                </button>
                                                <div *ngIf="file.type=='FILE'" class="border-t"></div>
                                                <div class="flex w-full">
                                                    <button *appAction="{ action: 'view', item: file }" mat-menu-item
                                                        (click)="previewFile(file)">
                                                        <mat-icon class="icon-size-4" svgIcon="feather:eye"></mat-icon>
                                                        <span>Preview</span>
                                                    </button>
                                                    <button *appAction="{ action: 'edit', item: file }" mat-menu-item
                                                        (click)="editFile(file)">
                                                        <mat-icon class="icon-size-4" svgIcon="feather:edit"></mat-icon>
                                                        <span>Edit</span>
                                                    </button>
                                                </div>
                                                <div class="border-t"></div>
                                                <button mat-menu-item [appAction]="{ action: 'rename', item: file }" (click)="_fileManagerComponent.renameItemDialog(file)">
                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:edit"></mat-icon>
                                                    <span>Rename</span>
                                                </button>
                                                
                                                <button mat-menu-item
                                                    [matMenuTriggerFor]="fmItemActionMenu_card_sub1">
                                                    <mat-icon class="icon-size-4" svgIcon="feather:folder"></mat-icon>
                                                    <span>Organize</span>
                                                </button> 
                                                <mat-menu #fmItemActionMenu_card_sub1="matMenu" class="file-manager-item-action-menu-sub">
                                                    <button mat-menu-item
                                                        [appAction]="{ action: 'move', item: file }"
                                                        (click)="move(file)">
                                                        <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                                                        <span>Move</span>
                                                    </button>
                                                    <button mat-menu-item
                                                        (click)="toggleStar(file)">
                                                        <mat-icon class="icon-size-4" svgIcon="heroicons_outline:star"></mat-icon>
                                                        <span>Star</span>
                                                    </button>
                                                    <button mat-menu-item
                                                        [matMenuTriggerFor]="labels.length>0 ? fmItemActionMenu_sub_labels : null">
                                                        <mat-icon class="icon-size-4" svgIcon="feather:tag"></mat-icon>
                                                        <span>Labels</span>
                                                    </button>
                                                <mat-menu #fmItemActionMenu_sub_labels="matMenu" class="file-manager-item-action-menu-sub">
                                                    <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                                                        <button mat-menu-item
                                                            (click)="toggleLabel(file.id,label.id, checkbox)"
                                                            matRipple>
                                                            <mat-checkbox
                                                                class="pointer-events-none label-chip" #checkbox
                                                                [ngClass]="labelColors[label.color]?.combined"
                                                                [color]="'primary'"
                                                                [checked]="selectedLabel(label.id, file.labels)"
                                                                [disableRipple]="true">
                                                                {{label?.name}}
                                                            </mat-checkbox>
                                                        </button>
                                                    </ng-container>
                                                </mat-menu>
                                                </mat-menu>
                                                <div class="border-t"></div>
                                                <button *appAction="{ action: 'delete', item: file }"
                                                    mat-menu-item
                                                    (click)="trash(file)">
                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                                                    <span>{{ 'Trash' | lpmLabel:'deleteLabelText' }}</span>
                                                </button>
                                            </mat-menu>
                                                <div class="aspect-[9/6]">
                                                    <div class="flex items-center justify-center h-full">
                                                        <!-- Icons -->
                                                        <div class="relative">
                                                                
                                                            <mat-icon
                                                                class="icon-size-14 text-hint opacity-50"
                                                                [svgIcon]="'heroicons_solid:document'"></mat-icon>
                                                            
                                                            <!--TODO - implement select case with ELSE catch all-->
                                                            <div
                                                                class="absolute left-0 bottom-0 px-1.5 rounded text-sm font-semibold leading-5 text-white no-select"
                                                                [ngClass]="getTypeColor(file.extension)">
                                                                {{file.extension.toUpperCase()}}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div class="flex flex-col flex-auto justify-center text-center text-sm font-medium no-select">
                                                    <div
                                                        class="truncate"
                                                        [matTooltip]="file.name">{{file.name}}</div>
                                                    <ng-container *ngIf="files.length">
                                                        <div class="text-secondary truncate">{{files.length}}</div>
                                                    </ng-container>
                                                </div>
                                            </div>
                                        </ng-container>

                                    </div>
                                </div>
                            </ng-container>
                        </div>
                    </ng-container>
                    <!-- Cards view - END -->

                    <!-- List Grid view -->
                    <!--Folders and Files are handled separately so that Folders always appears above Files-->
                    <ng-container *ngIf="viewMode === 'grid'" class="flex flex-col flex-auto sm:mb-18 overflow-hidden sm:overflow-y-auto">
                        <div class="fade-transition">
                            <ng-container *ngIf="assets.length > 0 ">
                                <div>
                                    <!-- Header -->
                                    <div
                                    [matSortDisableClear]="true"
                                        matSort 
                                        (matSortChange)="sortData($event)"
                                        class="file-grid z-10 sticky top-0 grid gap-4 py-4 grid-header__record-row shadow text-md font-semibold 
                                            text-secondary bg-gray-50 dark:bg-black dark:bg-opacity-5">
                                        
                                        <!--Select All Checkbox -->
                                        <div class="col-1 absolute" >
                                            <mat-checkbox [color]="'primary'" class="mt-2" [checked]="isAllRowsSelected" (change)="toggleCheckAll()">
                                            </mat-checkbox>
                                        </div>    

                                        <div class="col-1"></div>
                                        <div class="col-2" [mat-sort-header]="'FOLDER_NAME'">Name</div>
                                        <div
                                            class="col-3 hidden sm:hidden md:block lg:block"
                                           >
                                            Location
                                        </div>
                                        <div
                                            class="col-4 hidden sm:hidden md:hidden lg:block whitespace-nowrap"
                                            >
                                            Created By
                                        </div>
                                        <div
                                            class="col-5 hidden sm:hidden md:hidden lg:block"
                                         
                                            [mat-sort-header]="'FOLDER_UPDATED_DATE'">
                                            Last Edit
                                        </div>
                                        <div
                                            class="col-6 hidden sm:hidden md:block lg:block"
                                           >
                                            File Size
                                        </div>
                                    </div>
                                    <!-- Rows -->
                                    <!--TODO - determine if async/lazy loading pagination is needed
                                        *ngIf="(products$ | async) as products"-->
                                    <!-- //<fuse-loading-bar *ngIf="isLoading"></fuse-loading-bar> -->
                                    <ng-container *ngIf="!isLoading"> 
                                        <cdk-virtual-scroll-viewport
                                            part="file-manager-viewport"
                                            #viewport
                                            [itemSize]="assets.length"
                                            class="file-manager-viewport"
                                            [ngClass]="{
                                                'file-grid-adj-filter-open': filterPanel.expanded && !statsPanel.expanded && !multiItemSelectPanel.expanded,
                                                'file-grid-adj-stats-open': statsPanel.expanded && !filterPanel.expanded && !multiItemSelectPanel.expanded,
                                                'file-grid-adj-multi-open': multiItemSelectPanel.expanded && !statsPanel.expanded && !filterPanel.expanded,
                                                'file-grid-adj-both-open': statsPanel.expanded && filterPanel.expanded
                                                }">
                                            <div *ngFor="let asset of assets; let i = index; trackBy:trackByFn" class="list-item-row">
                                                <!--Record Rows - Folders -->
                                                <ng-container *ngIf="asset.type === 'FOLDER'">
                                                    <!-- capture onRightClick event before browser and display context menu object-->                                      
                                                    <div 
                                                        (mouseenter)="isBreadCrumbOpen=false"
                                                        mat-table
                                                        (contextmenu)="onRightClick($event, asset)"
                                                        matRipple
                                                        [matRippleRadius]="radius"
                                                        [matRippleColor]="color"
                                                        class="file-grid grid items-center gap-4 py-3 grid-header__record-row border-b cursor-pointer"
                                                        (dblclick)="navigateToFolder(asset.id)">

                                                         <!-- Checkbox -->
                                                         <div class="flex items-center absolute">
                                                            <mat-checkbox [checked]="isSelectedRow(asset)" (change)="toggleRowCheck($event.checked,asset)" class="" #checkbox [color]="'primary'" [disableRipple]="true">
                                                            </mat-checkbox>
                                                        </div>

                                                        <!-- Image -->
                                                        <div class="col-1 flex items-center">
                                                            <div class="folder-icon-div relative flex flex-0 items-center justify-center h-10 mr-6 rounded overflow-hidden">
                                                                <mat-icon
                                                                class="folder-icon"
                                                                [svgIcon]="util.getFileTypeImage('folder')"></mat-icon>
                                                            </div>
                                                        </div>
        
                                                        <!-- Name -->
                                                        <div class="flex items-center font-medium no-select cursor-pointer"> 
                                                            <div class="truncate"
                                                                matTooltip="{{asset.name}}" 
                                                                [routerLink]="['/apps/file-manager/folders/', asset.id]">
                                                                {{asset?.name}}
                                                            </div>

                                                             <!-- Shared -->
                                                             <mat-icon
                                                              matTooltip="Shared"
                                                              matTooltipPosition="above"
                                                              *ngIf="asset.accessCount>1"
                                                              class="flex justify-center icon-size-4 ml-1 "
                                                              [svgIcon]="'heroicons_solid:users'">
                                                         </mat-icon>
                                                            
                                                            <!-- Starred -->
                                                            <mat-icon
                                                                class="flex justify-center icon-size-4 ml-1 text-orange-500 dark:text-orange-400 fade-pulse"
                                                                *ngIf="asset.favourite"
                                                                [svgIcon]="'heroicons_solid:star'">
                                                            </mat-icon>
                                                           <!-- Label -->
                                                           <ng-container *ngIf="asset.labels && asset.labels.length > 0">
                                                                <div class="flex flex-wrap items-center justify-start -mx-1 ml-1">
                                                                    <ng-container *ngFor="let label of asset.labels">  
                                                                        <div
                                                                            class="asset-label m-1 py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap no-select"
                                                                            [ngClass]="labelColors[label.color]?.combined">
                                                                            {{label.name}}
                                                                        </div>
                                                                    </ng-container>
                                                                </div>
                                                            </ng-container>
                                                        </div>
        
                                                        
                                                        <div class="col-6 hidden sm:hidden md:block lg:block text-primary text-start cursor-pointer"
                                                            [routerLink]="getParentLink(asset.parent.id)" cdkOverlayOrigin  #trigger="cdkOverlayOrigin"
                                                            (mouseenter)="loadTooltipText(asset.id)">
                                                               {{asset.parent.name}}
                                                        </div>
                                                        <ng-template 
                                                            [cdkConnectedOverlayHasBackdrop]="false"  
                                                            cdkConnectedOverlay 
                                                            (overlayOutsideHover)="hideBreadCrumb()"
                                                            [cdkConnectedOverlayOrigin]="trigger"
                                                            [cdkConnectedOverlayOpen]="isBreadCrumbOpen && (hoveredAssetId == asset.id)">
                                                        
                                                            <!--Asset Breadcrumb  -->
                                                            <nav
                                                             (mouseleave)="hideBreadCrumb()"
                                                                class="flex px-5 py-3 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
                                                                aria-label="Breadcrumb">
                                                                <div  class="flex items-center ms-3 space-x-2" *ngIf="assetPaths[asset.id]">
                                                                    <ng-container *ngFor="let path of assetPaths[asset.id]; let last = last;">
                                                                        <ng-container *ngIf="!last">
                                                                            <a *ngIf="path.name==='My Drive'" class="text-primary cursor-pointer"
                                                                                [routerLink]="['/apps/file-manager']">{{path.name}}</a>
                                                                            <a *ngIf="path.name!=='My Drive'" class="text-primary cursor-pointer"
                                                                                [routerLink]="['/apps/file-manager/folders/', path.id]">{{path.name}}</a>
                                                                        </ng-container>
                                                                        <ng-container *ngIf="last">
                                                                            <div>{{path.name}}</div>
                                                                        </ng-container>
                                                                        <ng-container *ngIf="!last">
                                                                            <div class="">/</div>
                                                                        </ng-container>
                                                                    </ng-container>
                                                                </div>
                                                        
                                                                <div *ngIf="!assetPaths[asset.id]">
                                                                    Loading
                                                                </div>
                                                            </nav>
                                                        </ng-template>
        
                                                        <!-- Uploaded By -->
                                                        <div class="col-4 col-3 text-center hidden sm:hidden md:hidden lg:block no-select"
                                                        [innerHTML]="(asset['innerDiv'])" [matTooltip]="asset.createdBy | fullName">
                                                            {{asset?.createdBy | fullName}}
                                                    </div>
                                                    
                                                        <!-- Modified -->
                                                        <div class="col-5 hidden sm:hidden md:hidden lg:block no-select">
                                                            {{asset.updatedDate | date : 'MM/dd/yyyy'}}
                                                        </div>
        
                                                        <!-- File Size -->
                                                        <div class="col-6 hidden sm:hidden md:block lg:block no-select">
                                                        </div>
                                                        <!-- Last Edit Indicator -->
                                                    
                                                        <div class="row flex justify-end">
                                                            <div class="row flex justify-end list-item-inline-actions">
                                                                <button mat-icon-button matTooltip="Rename"
                                                                    [appAction]="{ action: 'rename', item: asset }"
                                                                    (click)="_fileManagerComponent.renameItemDialog(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:edit-3"></mat-icon>
                                                                </button>
                                                                <button mat-icon-button matTooltip="Favorite" 
                                                                    (click)="toggleStar(asset)">
                                                                    <mat-icon
                                                                        class="icon-size-4"
                                                                        [ngClass]="{'text-orange-500 dark:text-red-400': asset.favourite}"
                                                                        [svgIcon]="'feather:star'"></mat-icon>
                                                                </button>                                                        
                                                            </div>
                                                            <button mat-icon-button matTooltip="Menu"
                                                                class="list-item-inline-action-menu"
                                                                [matMenuTriggerFor]="fmItemActionMenu">
                                                                <mat-icon
                                                                    class="icon-size-4"
                                                                    [svgIcon]="'heroicons_solid:ellipsis-vertical'">
                                                                </mat-icon>
                                                            </button>
                                                            <mat-menu #fmItemActionMenu="matMenu" class="file-manager-item-action-menu">
                                                                <button mat-menu-item [appAction]="{ action: 'share', item: asset }" (click)="shared(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:share"></mat-icon>
                                                                    <span>Share</span>
                                                                </button>

                                                                <div class="border-t"></div>
                                                                <button mat-menu-item [appAction]="{ action: 'rename', item: asset }" (click)="_fileManagerComponent.renameItemDialog(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:edit"></mat-icon>
                                                                    <span>Rename</span>
                                                                </button>
                                                                <button mat-menu-item
                                                                    [matMenuTriggerFor]="fmItemActionMenu_sub1">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:folder"></mat-icon>
                                                                    <span>Organize</span>
                                                                </button>
                                                                <mat-menu #fmItemActionMenu_sub1="matMenu" class="file-manager-item-action-menu-sub">
                                                                    <button mat-menu-item
                                                                        [appAction]="{ action: 'move', item: asset }"
                                                                        (click)="move(asset)">
                                                                        <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                                                                        <span>Move</span>
                                                                    </button>
                                                                    <button mat-menu-item
                                                                        (click)="toggleStar(asset)">
                                                                        <mat-icon 
                                                                            class="icon-size-4"
                                                                            [ngClass]="{'text-orange-500 dark:text-red-400': asset.favourite}" 
                                                                            svgIcon="heroicons_outline:star">
                                                                        </mat-icon>
                                                                        <span>{{asset.favourite ? "Remove Star" : "Star"}}</span>
                                                                    </button>
                                                                    <button mat-menu-item
                                                                        [matMenuTriggerFor]="labels.length>0 ? fmItemActionMenu_sub_labels : null">
                                                                        <mat-icon class="icon-size-4" svgIcon="feather:tag"></mat-icon>
                                                                        <span>Labels</span>
                                                                    </button>
                                                                    <mat-menu #fmItemActionMenu_sub_labels="matMenu" class="file-manager-item-action-menu-sub">
                                                                        <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                                                                            <button mat-menu-item
                                                                                (click)="toggleLabel(asset.id,label.id, checkbox)"
                                                                                matRipple>
                                                                                <mat-checkbox
                                                                                    class="pointer-events-none label-chip" #checkbox
                                                                                    [ngClass]="labelColors[label.color]?.combined"
                                                                                    [color]="'primary'"
                                                                                    [checked]="selectedLabel(label.id, asset.labels)"
                                                                                    [disableRipple]="true">
                                                                                    {{label?.name}}
                                                                                </mat-checkbox>
                                                                            </button>
                                                                        </ng-container>
                                                                    </mat-menu>
                                                                </mat-menu>
                                                                
                                                                <!-- Divider -->
                                                                <div class="border-t"></div>
                                                                <button *appAction="{ action: 'delete', item: asset }"
                                                                    mat-menu-item
                                                                    (click)="trash(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                                                                    <span>{{ 'Trash' | lpmLabel:'deleteLabelText' }}</span>
                                                                </button>
                                                            </mat-menu>
                                                        </div>
        
                                                    </div>
                                                </ng-container>                      
        
                                                <!-- Record Rows - Files -->
                                                <ng-container *ngIf="asset.type === 'FILE'" class="list-item-row">
                                                    <div
                                                        (mouseenter)="isBreadCrumbOpen=false"
                                                        matRipple
                                                        [matRippleRadius]="radius"
                                                        [matRippleColor]="color"
                                                        mat-table
                                                        (contextmenu)="onRightClick($event, asset)"
                                                        (click)="onRowClick(asset)"
                                                        (dblclick)="onFileDblClick(asset)"
                                                        [class.selected]="isSelected(asset)"
                                                        class="file-grid grid items-center gap-4 py-3 grid-header__record-row border-b cursor-pointer">
                                                        
                                                         <!-- Checkbox -->
                                                         <div class="flex items-center absolute">
                                                            <mat-checkbox (click)="$event.stopPropagation()" [checked]="isSelectedRow(asset)" (change)="toggleRowCheck($event.checked,asset)" class="" #checkbox [color]="'primary'" [disableRipple]="true">
                                                            </mat-checkbox>
                                                        </div>

                                                        <div class="flex items-center">
                                                            <div class="file-icon relative flex flex-0 items-center justify-center ml-2 mr-2">
                                                                <mat-icon class="file-icon-size"
                                                                [svgIcon]="util.getFileTypeImage(asset.extension)"></mat-icon>
                                                            </div>
                                                        </div>
        
                                                        <div class="flex items-center no-select cursor-pointer file-manager-item-name-row">
                                                            <div matTooltip="{{asset.name}}"  
                                                                class="file-manager-item-name truncate">
                                                                {{asset.name}}
                                                            </div>
                                                            <mat-icon
                                                                class="flex justify-center icon-size-4 ml-1 text-orange-500 dark:text-orange-400 fade-pulse"
                                                                *ngIf="asset.favourite"
                                                                [svgIcon]="'heroicons_solid:star'">
                                                            </mat-icon>
                                                            <!-- Label -->
                                                            <ng-container *ngIf="asset.labels && asset.labels.length > 0">
                                                                <div class="flex flex-wrap items-center justify-start -mx-1 ml-1">
                                                                    <ng-container *ngFor="let label of asset.labels">  
                                                                        <div
                                                                            class="asset-label m-1 py-0.5 px-2.5 rounded-full text-sm font-medium whitespace-nowrap no-select"
                                                                            [ngClass]="labelColors[label.color]?.combined">
                                                                            {{label.name}}
                                                                        </div>
                                                                    </ng-container>
                                                                </div>
                                                            </ng-container>
                                                    
                                                        </div>
        
                                                        <!-- Location -->
                                                        <div
                                                            class="asset-location items-center flex justify-start cursor-pointer"
                                                            [routerLink]="getParentLink(asset.parent.id)" 
                                                            cdkOverlayOrigin 
                                                            #trigger="cdkOverlayOrigin"
                                                            (mouseenter)="loadTooltipText(asset.id)">
                                                            <mat-icon
                                                                class="icon-size-4 opacity-80 mr-2"
                                                                [svgIcon]="util.getFileTypeImage('folder')"></mat-icon>
                                                                {{asset.parent.name}}
                                                        </div>

                                                        <ng-template 
                                                            [cdkConnectedOverlayHasBackdrop]="false"  
                                                            cdkConnectedOverlay 
                                                            (overlayOutsideHover)="hideBreadCrumb()"
                                                            [cdkConnectedOverlayOrigin]="trigger"
                                                            [cdkConnectedOverlayOpen]="isBreadCrumbOpen && (hoveredAssetId == asset.id)"
                                                            (overlayOutsideClick)="isBreadCrumbOpen = false">
                                                            
                                                            <div @fadeIn (@fadeIn.start)="animationStarted($event)">
                                                                <!--Asset Breadcrumb  -->
                                                                <nav
                                                                    class="asset-location-breadcrumb flex px-5 py-3 text-gray-700 border border-gray-200 rounded-lg bg-gray-50 dark:bg-gray-800 dark:border-gray-700"
                                                                    (mouseleave)="hideBreadCrumb()"                                                        
                                                                    aria-label="Breadcrumb">
                                                                    <div  class="flex items-center ms-3 space-x-2" *ngIf="assetPaths[asset.id]">
                                                                        <!--TODO - add logic to restrict moving UP directory, if there is a parameter set to limit navigation-->
                                                                        <ng-container *ngFor="let path of assetPaths[asset.id]; let last = last;">
                                                                            <ng-container *ngIf="!last">
                                                                                <a *ngIf="path.name==='My Drive'" class="asset-location-spec text-primary cursor-pointer"
                                                                                    [routerLink]="['/apps/file-manager']">{{path.name}}</a>
                                                                                <a *ngIf="path.name!=='My Drive'" class="asset-location-spec text-primary cursor-pointer"
                                                                                    [routerLink]="['/apps/file-manager/folders/', path.id]">{{path.name}}</a>
                                                                            </ng-container>
                                                                            <ng-container *ngIf="last">
                                                                                <div class="mr-2">{{path.name}}</div>
                                                                            </ng-container>
                                                                            <ng-container *ngIf="!last">
                                                                                <mat-icon class="icon-size-4" svgIcon="heroicons_outline:chevron-right"></mat-icon>
                                                                            </ng-container>
                                                                        </ng-container>
                                                                    </div>

                                                                    <div *ngIf="!assetPaths[asset.id]">
                                                                        Loading
                                                                    </div>
                                                                </nav>
                                                            </div>
                                                       
                                                        </ng-template>
        
                                                        <!-- Uploaded By -->
                                                        <div class="hidden col-3 hidden sm:hidden md:hidden lg:block no-select">
                                                            {{asset?.createdBy | fullName}}
                                                        </div>
                                                        
                                                        <!-- Modified -->
                                                        <div class="hidden sm:hidden md:hidden lg:block no-select">
                                                            {{asset.updatedDate | date : 'MM/dd/yyyy'}}
                                                        </div>
        
                                                        <!-- File Size -->
                                                        <div class="hidden sm:hidden md:block lg:block no-select">
                                                            {{asset.size | fileSize}}
                                                        </div>
                                                        <!-- Last Edit Indicator -->
                                            
                                                        <div class="row flex justify-end">
                                                            <div class="row flex justify-end list-item-inline-actions">
                                                                <button mat-icon-button matTooltip="Download"
                                                                    [appAction]="{ action: 'download', item: asset }"
                                                                    (click)="stopPropagation($event); download(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                                                                </button>
                                                                <button mat-icon-button matTooltip="Rename"
                                                                    [appAction]="{ action: 'rename', item: asset }"
                                                                    (click)="stopPropagation($event); _fileManagerComponent.renameItemDialog(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:edit-3"></mat-icon>
                                                                </button>
                                                                <button mat-icon-button matTooltip="Favorite" 
                                                                    (click)="stopPropagation($event); toggleStar(asset)">
                                                                    <mat-icon
                                                                        class="icon-size-4"
                                                                        [ngClass]="{'text-orange-500 dark:text-red-400': asset.favourite}"
                                                                        [svgIcon]="'feather:star'"></mat-icon>
                                                                </button>
                                                                 
                                                            </div>
                                                            <button mat-icon-button matTooltip="Menu"
                                                                    class="list-item-inline-action-menu"
                                                                    (click)="stopPropagation($event)"
                                                                    [matMenuTriggerFor]="fmItemActionMenu">
                                                                    <mat-icon
                                                                        class="icon-size-4"
                                                                        [svgIcon]="'heroicons_solid:ellipsis-vertical'">
                                                                    </mat-icon>
                                                            </button>
                                                            <mat-menu #fmItemActionMenu="matMenu" class="file-manager-item-action-menu">
                                                                <button mat-menu-item
                                                                    [appAction]="{ action: 'download', item: asset }"
                                                                    (click)="stopPropagation($event); download(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                                                                    <span>Download</span>
                                                                </button>
                                                                <button mat-menu-item [appAction]="{ action: 'share', item: asset }" (click)="shared(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:share"></mat-icon>
                                                                    <span>Share</span>
                                                                </button>
                                                                <div *ngIf="asset.type=='FILE'" class="border-t"></div>
                                                                <div class="flex w-full">
                                                                    <button *appAction="{ action: 'view', item: asset }" mat-menu-item
                                                                        (click)="previewFile(asset)">
                                                                        <mat-icon class="icon-size-4" svgIcon="feather:eye"></mat-icon>
                                                                        <span>Preview</span>
                                                                    </button>
                                                                    <button *appAction="{ action: 'edit', item: asset }" mat-menu-item
                                                                        [disabled]="util.isLockedForCurrentUser(asset)"
                                                                        (click)="editFile(asset)">
                                                                        <mat-icon class="icon-size-4" svgIcon="feather:edit"></mat-icon>
                                                                        <span>Edit</span>
                                                                    </button>
                                                                </div>
                                                                <div class="border-t"></div>
                                                                <button mat-menu-item [appAction]="{ action: 'rename', item: asset }" (click)="_fileManagerComponent.renameItemDialog(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:edit"></mat-icon>
                                                                    <span>Rename</span>
                                                                </button>
                                                                <button mat-menu-item
                                                                    [matMenuTriggerFor]="fmItemActionMenu_sub1">
                                                                    <mat-icon class="icon-size-4" svgIcon="feather:folder"></mat-icon>
                                                                    <span>Organize</span>
                                                                </button>
                                                                <mat-menu #fmItemActionMenu_sub1="matMenu" class="file-manager-item-action-menu-sub">
                                                                    <button mat-menu-item
                                                                        [appAction]="{ action: 'move', item: asset }"
                                                                        (click)="move(asset)">
                                                                        <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                                                                        <span>Move</span>
                                                                    </button>
                                                                    <button mat-menu-item
                                                                        (click)="toggleStar(asset)">
                                                                        <mat-icon
                                                                            class="icon-size-4"
                                                                            [ngClass]="{'text-orange-500 dark:text-red-400': asset.favourite}"
                                                                            svgIcon="heroicons_outline:star">
                                                                        </mat-icon>
                                                                        <span>{{asset.favourite ? "Remove Star" : "Star"}}</span>
                                                                    </button>
                                                                    <button mat-menu-item
                                                                        [matMenuTriggerFor]="labels.length>0 ? fmItemActionMenu_sub_labels : null">
                                                                        <mat-icon class="icon-size-4" svgIcon="feather:tag"></mat-icon>
                                                                        <span>Labels</span>
                                                                    </button>
                                                                    <mat-menu #fmItemActionMenu_sub_labels="matMenu" class="file-manager-item-action-menu-sub">
                                                                        <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                                                                            <button mat-menu-item
                                                                                (click)="toggleLabel(asset.id,label.id, checkbox)"
                                                                                matRipple>
                                                                                <mat-checkbox
                                                                                    class="pointer-events-none label-chip" #checkbox
                                                                                    [ngClass]="labelColors[label.color]?.combined"
                                                                                    [color]="'primary'"
                                                                                    [checked]="selectedLabel(label.id, asset.labels)"
                                                                                    [disableRipple]="true">
                                                                                    {{label?.name}}
                                                                                </mat-checkbox>
                                                                            </button>
                                                                        </ng-container>
                                                                    </mat-menu>
                                                                </mat-menu>
                                                                <div class="border-t"></div>
                                                                <button *appAction="{ action: 'delete', item: asset }"
                                                                    mat-menu-item
                                                                    (click)="trash(asset)">
                                                                    <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                                                                    <span>{{ 'Trash' | lpmLabel:'deleteLabelText' }}</span>
                                                                </button>
                                                            </mat-menu>
                                                        </div>
                                                    </div>
                                                </ng-container>
                                            </div>
                                        </cdk-virtual-scroll-viewport>
                                    </ng-container>
                                    
                    
                                </div>
                                <!--Pagination-->
                                
                                <mat-paginator
                                    
                                    [ngClass]="{'pointer-events-none': isLoading}"
                                    [length]="total"
                                    [pageIndex]="page.page"
                                    [pageSize]="page.size"
                                    [pageSizeOptions]="pageLimitList"
                                    (page)="onPageChanged($event)"
                                    [showFirstLastButtons]="true"></mat-paginator>
                            </ng-container>
                            <!-- Cards view - END -->
        
                        
                            </div>
                        </ng-container>

                    <!-- List Grid view - END -->

                </ng-container>

                <!-- No items template -->
                <!--TODO - explore animation/transition; consider explicit linedashed drag and drop area-->
                <ng-template #noItems>
                    <div class="p-4 file-manager-viewport-empty">
                        <div  *ngIf="!isLoading" class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                            <mat-icon
                                class="icon-size-24"
                                [svgIcon]="'heroicons_outline:folder-open'"></mat-icon>
                            <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">No items to display</div>
                        </div>

                        <div  *ngIf="isLoading" class="flex flex-auto flex-col items-center justify-center h-100 min-h-100 max-h-400 border-2 border-dashed border-gray-300 rounded-2xl bg-gray-100 dark:bg-transparent">
                            <ngx-loading [show]="isLoading" [config]="{ backdropBorderRadius: '3px' }"></ngx-loading>
                            <div class="mt-4 text-2xl font-semibold tracking-tight text-secondary">Loading Data ... Please Wait</div>
                        </div>
                    </div>
                </ng-template>
                 
                <!--Scroll to top-->
                <button mat-mini-fab
                    *ngIf="viewMode === 'grid' && showScrollToTopButton"
                    matTooltip="Scroll to top"
                    (click)="scrollToTop()"
                    [color]="'primary'" 
                    class="viewport-scroll-return-btn">
                    <mat-icon [svgIcon]="'feather:chevron-up'"></mat-icon>
                </button>
            </div>

        </mat-drawer-content>

    </mat-drawer-container>

    <!-- a hidden div is created to set the position of appearance of the menu--> 
    <div 
    #fmActionMenuMainTrigger   
        style="visibility: hidden; position: fixed;" 
        [style.left.px]="menuTopLeftPosition.x" 
        [style.top.px]="menuTopLeftPosition.y" 
        [matMenuTriggerFor]="fmItemActionMenuItem"
        #fmItemActionMenuItemTrigger="matMenuTrigger">
    </div> 
    <!--TODO - split functions for context action menu for file & folders-->
    <mat-menu #fmItemActionMenuItem="matMenu" class="file-manager-item-action-menu">
        <ng-template matMenuContent let-item="item"> 
            <button class="menu-header">Item: {{item?.name}} {{item?.type}}</button> 
            <!--TODO catch type of record from the file-manager.types.ts Item object-->
            <!--TODO hide 'download' and other options that are for Files only-->
            <button mat-menu-item
                [appAction]="{ action: 'download', item: item }"
                (click)="download(item)">
                <mat-icon class="icon-size-4" svgIcon="feather:download"></mat-icon>
                <span>Downloads</span>
            </button>
            <button mat-menu-item [appAction]="{ action: 'share', item: item }" (click)="shared(item)">
                <mat-icon class="icon-size-4" svgIcon="mat_outline:share"></mat-icon>
                <span>Share</span>
            </button>
            <div *ngIf="item.type=='FILE'" class="border-t"></div>
            <div class="flex w-full">
                <button *appAction="{ action: 'view', item: item }" mat-menu-item
                    (click)="previewFile(item)">
                    <mat-icon class="icon-size-4" svgIcon="feather:eye"></mat-icon>
                    <span>Preview</span>
                </button>
                <button *appAction="{ action: 'edit', item: item }" mat-menu-item
                    (click)="editFile(item)">
                    <mat-icon class="icon-size-4" svgIcon="feather:edit"></mat-icon>
                    <span>Edit</span>
                </button>
            </div>
            <div class="border-t"></div>
            <button mat-menu-item [appAction]="{ action: 'rename', item: item }" (click)="_fileManagerComponent.renameItemDialog(item)">
                <mat-icon class="icon-size-4" svgIcon="mat_outline:edit"></mat-icon>
                <span>Rename</span>
            </button>
            <button mat-menu-item
                [matMenuTriggerFor]="fmItemActionMenu_sub1">
                <mat-icon class="icon-size-4" svgIcon="feather:folder"></mat-icon>
                <span>Organize</span>
            </button>
            <mat-menu #fmItemActionMenu_sub1="matMenu" class="file-manager-item-action-menu-sub">
                <button mat-menu-item
                    [appAction]="{ action: 'move', item: item }"
                    (click)="move(item)">
                    <mat-icon class="icon-size-4" svgIcon="mat_outline:drive_file_move"></mat-icon>
                    <span>Move</span>
                </button>
                <button mat-menu-item
                    (click)="toggleStar(item)">
                    <mat-icon 
                        class="icon-size-4"
                        [ngClass]="{'text-orange-500 dark:text-red-400': item.favourite}" 
                        svgIcon="heroicons_outline:star">
                    </mat-icon>
                    <span><span>{{item?.favourite? "Remove Star" : "Star"}}</span></span>
                </button>
                <button mat-menu-item
                    [matMenuTriggerFor]="labels.length>0 ? fmItemActionMenu_sub_labels : null">
                    <mat-icon class="icon-size-4" svgIcon="feather:tag"></mat-icon>
                    <span>Labels</span>
                </button>
                <mat-menu #fmItemActionMenu_sub_labels="matMenu" class="file-manager-item-action-menu-sub">
                    <ng-container *ngFor="let label of labels; trackBy: trackByFn">
                        <button mat-menu-item
                            (click)="toggleLabel(item.id,label.id, checkbox)"
                            matRipple>
                            <mat-checkbox
                                class="pointer-events-none label-chip" #checkbox
                                [ngClass]="labelColors[label.color]?.combined"
                                [color]="'primary'"
                                [checked]="selectedLabel(label.id, item.labels)"
                                [disableRipple]="true">
                                {{label?.name}}
                            </mat-checkbox>
                        </button>
                    </ng-container>
                </mat-menu>
            </mat-menu>
            <!-- Divider -->
            <div class="border-t"></div>
            <button *appAction="{ action: 'delete', item: item }"
                mat-menu-item
                (click)="trash(item)">
                <mat-icon class="icon-size-4" svgIcon="mat_outline:delete"></mat-icon>
                <span>{{ 'Trash' | lpmLabel:'deleteLabelText' }}</span>
            </button>
        </ng-template>
    </mat-menu>
    
</div>

